"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JEVMWallet = exports.JVMWallet = exports.MCNWallet = void 0;
const ethers_1 = require("ethers");
const chain_1 = require("../chain");
const network_1 = require("../network");
const utils_1 = require("../utils");
const encoding = __importStar(require("../utils/encoding"));
class NodeManager {
    mnemonic;
    constructor(mnemonic) {
        this.mnemonic = mnemonic;
    }
    derivePrivateKey(chain, index) {
        const hdNode = ethers_1.HDNodeWallet.fromPhrase(this.mnemonic, '', `m/44'/${chain.vm.hdPath}'/0'/0`);
        return hdNode.deriveChild(index).privateKey.substring(2);
    }
}
class MCNWallet {
    hrp;
    nodeManager;
    mnemonic;
    privateKey;
    chainsWallets = new Map();
    constructor(hrp, data) {
        this.hrp = hrp;
        if (typeof data === 'string') {
            this.recover(data);
        }
        else if (typeof data === 'number') {
            this.generate(data);
        }
    }
    getAddress(chain) {
        return this.getWallet(chain).getAddress();
    }
    getWallet(chain) {
        if (!this.chainsWallets.has(chain.id)) {
            const wallet = this.getVMWallet(chain);
            this.chainsWallets.set(chain.id, wallet);
        }
        return this.chainsWallets.get(chain.id);
    }
    getJEVMWallet(chain) {
        return this.getWallet(chain);
    }
    getWallets() {
        const wallets = [];
        for (const wallet of this.chainsWallets.values()) {
            wallets.push(wallet);
        }
        return wallets;
    }
    setHrp(hrp) {
        this.hrp = hrp;
        this.chainsWallets.clear();
    }
    getVMWallet(chain) {
        const privateKey = this.getVMWalletPrivateKey(chain);
        switch (chain.vm.type) {
            case chain_1.VMType.EVM: {
                return new JEVMWallet(privateKey, this.hrp, chain);
            }
            case chain_1.VMType.JVM: {
                return new JVMWallet(privateKey, this.hrp, chain);
            }
            default: {
                throw new utils_1.WalletError(`unsupported vm type: ${chain.vm.type}`);
            }
        }
    }
    getVMWalletPrivateKey(chain) {
        if (this.nodeManager !== undefined) {
            return this.nodeManager.derivePrivateKey(chain, 0);
        }
        else if (this.privateKey !== undefined) {
            return this.privateKey;
        }
        throw new utils_1.WalletError('missing recovery data to build wallet');
    }
    setMnemonic(mnemonic) {
        if (!ethers_1.Mnemonic.isValidMnemonic(mnemonic)) {
            throw new utils_1.WalletError('invalid mnemonic provided');
        }
        this.nodeManager = new NodeManager(mnemonic);
        this.mnemonic = mnemonic;
    }
    setPrivateKey(privateKey) {
        // should only be hex or bs58 private key after validate
        if (encoding.isHex(privateKey)) {
            privateKey = encoding.hasHexPrefix(privateKey) ? privateKey.substring(2) : privateKey;
        }
        else {
            privateKey = encoding.decodeCB58(privateKey.split('-')[1]).toHex();
        }
        this.privateKey = privateKey;
    }
    /**
     * @deprecated
     */
    static recover(data, hrp) {
        if (typeof hrp === 'undefined') {
            hrp = network_1.MainNetwork.hrp;
        }
        return new MCNWallet(hrp, data);
    }
    recover(data) {
        if (ethers_1.Mnemonic.isValidMnemonic(data)) {
            this.setMnemonic(data);
        }
        else if ((0, utils_1.validatePrivateKey)(data)) {
            this.setPrivateKey(data);
        }
        else {
            throw new utils_1.WalletError('invalid recovery data provided');
        }
    }
    /**
     * @deprecated
     */
    static generate(words = 12, hrp) {
        if (typeof hrp === 'undefined') {
            hrp = network_1.MainNetwork.hrp;
        }
        return new MCNWallet(hrp, words);
    }
    generate(wordsCount) {
        if (wordsCount % 3 !== 0 || wordsCount < 12 || wordsCount > 24) {
            throw new utils_1.WalletError(`words count must be min 12 and max 24 and multiple of 3 but got: ${wordsCount}`);
        }
        const strength = (wordsCount / 3) * 4;
        const mnemonic = ethers_1.Mnemonic.fromEntropy((0, ethers_1.randomBytes)(strength)).phrase;
        this.recover(mnemonic);
    }
}
exports.MCNWallet = MCNWallet;
class AbstractVMWallet {
    keyPair;
    chain;
    juneoAddress;
    address;
    constructor(privateKey, hrp, chain) {
        this.keyPair = new utils_1.ECKeyPair(privateKey);
        this.chain = chain;
        this.juneoAddress = (0, utils_1.encodeJuneoAddress)(this.keyPair.publicKey, hrp);
    }
    getAddress() {
        if (typeof this.address === 'undefined') {
            return this.getJuneoAddress();
        }
        return this.address;
    }
    getJuneoAddress() {
        if (this.chain.aliases.length > 0) {
            return `${this.chain.aliases[0]}-${this.juneoAddress}`;
        }
        return `${this.chain.id}-${this.juneoAddress}`;
    }
    getKeyPair() {
        return this.keyPair;
    }
    async sign(bytes) {
        return this.keyPair.sign(bytes);
    }
    matches(address) {
        return address.matches(this.getAddress()) || address.matches(this.juneoAddress);
    }
}
class JVMWallet extends AbstractVMWallet {
    jvmPrivateKey;
    constructor(privateKey, hrp, chain) {
        super(privateKey, hrp, chain);
        const jvmKey = encoding.encodeCB58(utils_1.JuneoBuffer.fromString(privateKey, 'hex'));
        this.jvmPrivateKey = `${utils_1.JVMPrivateKeyPrefix}${jvmKey}`;
    }
}
exports.JVMWallet = JVMWallet;
class JEVMWallet extends AbstractVMWallet {
    evmWallet;
    nonce = BigInt(0);
    synchronized = false;
    constructor(privateKey, hrp, chain) {
        super(privateKey, hrp, chain);
        this.evmWallet = new ethers_1.Wallet(privateKey);
        this.address = this.evmWallet.address;
    }
}
exports.JEVMWallet = JEVMWallet;
